import React from 'react';
import PropTypes from 'prop-types';

const DetailsHeading = ({ name, tstyle='' }) => {
  return (
    <h1 className={`text-xl text-gray-800 text-center justify-center ${tstyle}`}>
      {name}
    </h1>
  );
};

DetailsHeading.propTypes = {
  name: PropTypes.string.isRequired,
  tstyle: PropTypes.string,
};

export default DetailsHeading;
